document.addEventListener('DOMContentLoaded', function () {
  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) return;

  // Sélecteur précis basé sur l'ID du bloc
  const textBlock = document.querySelector('.text-block--text_xrnftG');
  if (!textBlock) return;

  function getSelectedVariantName() {
    const selectedOption = variantPicker.querySelector(
      'select option[selected], fieldset input:checked'
    );
    return selectedOption ? selectedOption.value : null;
  }

  function updateDisplay(name) {
    if (name) textBlock.textContent = name;
  }

  // Affichage au chargement de la page
  updateDisplay(getSelectedVariantName());

  // Mise à jour à chaque changement de variant
  variantPicker.addEventListener('change', function () {
    setTimeout(() => updateDisplay(getSelectedVariantName()), 50);
  });
});
